<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
        :title="`${localization('Cards Tasks')}`"
        :text="`${localization('List of tasks returned from cards topics.')}`"
        :total="totalTasks"
        :buttonText="`${localization('Add new task')}`"
        @toggleModal="openModal()"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          ref="customTable"
          :count="totalTasks"
          :DataItems="tasks"
          @Refresh="refresh"
          @reset="filter = {}"
          :filter="filter"
          hidden_export_import
          :empty-state-title="`${localization('No tasks found')}`"
          :empty-state-text="`${localization('Your search did not match any task. Please Check your inputs and try again.')}`"
          :empty-state-image="require('@/assets/new-theme/empty-state.png')"
          :show-default-empty-actions="false"
          @reset-filters="filter = {}"
          @toggleModal="openModal()"
        >
          <template #columns>
            <el-table-column
              prop="topic_card_name"
              :label="`${localization('Topic Card')}`"
              sortable
              align="left"
              header-align="left"
            >
            </el-table-column>
            <el-table-column
              prop="sub_topics_card_name"
              :label="`${localization('Sub Topic Card')}`"
              sortable
              align="left"
              header-align="left"
            >
            </el-table-column>
             <el-table-column
              prop="desc"
              :label="`${localization('Description')}`"
              align="left"
              header-align="left"
            >
            </el-table-column>
             <el-table-column
              :label="`${localization('Actions')}`"
              width="180"
              align="left"
              header-align="left"
            >
              <template slot-scope="scope">
                <div class="table_actions">
                  <img
                    v-if="!scope.row.deleted_at"
                    @click="openModal(scope.row)"
                    src="@/assets/new-theme/edit.png"
                    alt="edit"
                    class="action_icon"
                    v-tooltip.top-center="`${localization('Edit')}`"
                  />
                  <img
                    v-if="!scope.row.deleted_at"
                    @click="deleteTask(scope.row.id)"
                    src="@/assets/new-theme/delete-button-table.png"
                    alt="delete"
                    class="action_icon mx-2"
                    style="width: 40px !important; height: 40px !important;"
                    v-tooltip.top-center="`${localization('Delete')}`"
                  />
                  <img
                    v-if="scope.row.deleted_at"
                    @click="restoreTask(scope.row.id)"
                    src="@/assets/images/icons/reverse-left.png"
                    alt="restore"
                    class="action_icon"
                    v-tooltip.top-center="`${localization('Restore')}`"
                  />
                </div>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ isEdit ? localization("Edit task card") : localization("Add a new task card") }}
        </h3>
        <p class="description">
          {{ localization("Fill in the details below to save the task card.") }}
        </p>
      </div>

      <el-form :model="form" :rules="rules" ref="taskForm" class="task-form">
        <el-form-item prop="topic_card_id">
          <AppInputLabel :text="`${localization('Topic Card')}`" :star="true"></AppInputLabel>
          <el-select
            v-model="form.topic_card_id"
            clearable
            :placeholder="`${localization('Select Topic Card')}`"
            style="width: 100%"
            @change="handleTopicChange"
          >
            <el-option
              v-for="item in topicCards"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sub_topics_card_id">
          <AppInputLabel :text="`${localization('Sub Topic Card')}`" :star="true"></AppInputLabel>
          <el-select
            v-model="form.sub_topics_card_id"
            clearable
            :placeholder="`${localization('Select Sub Topic Card')}`"
            style="width: 100%"
            :disabled="!form.topic_card_id"
          >
            <el-option
              v-for="item in subTopicCards"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="desc">
          <AppInputLabel :text="`${localization('Description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="form.desc"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>

      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel" :disabled="loading">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "CardsTasks",

  data() {
    return {
      filter: {
        with_deleted: false
      },
      dialogVisible: false,
      isEdit: false,
      selectedId: null,
      form: {
        topic_card_id: "",
        sub_topics_card_id: "",
        desc: ""
      },
      rules: {
        topic_card_id: [
          { required: true, message: this.localization("Please select a topic card"), trigger: "change" }
        ],
        sub_topics_card_id: [
          { required: true, message: this.localization("Please select a sub topic card"), trigger: "change" }
        ],
        desc: [
          { required: true, message: this.localization("Please enter a description"), trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    tasks() {
      return this.$store.getters["task_cards/tasks"];
    },
    totalTasks() {
      return this.$store.getters["task_cards/totalTasks"];
    },
    loading() {
      return this.$store.getters["task_cards/loading"];
    },
    topicCards() {
      return this.$store.getters["topics_card/topicsCardLookups"];
    },
    subTopicCards() {
      return this.$store.getters["sub_topics_card/subTopicsCardLookups"];
    }
  },
  methods: {
    refresh(query) {
      if (arguments.length > 0 && query) {
        this.$store.dispatch("task_cards/GetTaskCards", { query: query });
      } else if (this.$refs.customTable) {
        this.$refs.customTable.Refresh();
      } else {
        this.$store.dispatch("task_cards/GetTaskCards", { query: this.filter });
      }
    },
    fetchLookups() {
      this.$store.dispatch("topics_card/GetTopicsCardLookups");
    },
    openModal(row = null) {
      if (row) {
        this.isEdit = true;
        this.selectedId = row.id;
        this.form = {
          topic_card_id: row.topic_card_id,
          sub_topics_card_id: row.sub_topics_card_id,
          desc: row.desc
        };
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: row.topic_card_id });
      } else {
        this.isEdit = false;
        this.selectedId = null;
        this.form = {
          topic_card_id: "",
          sub_topics_card_id: "",
          desc: ""
        };
      }
      this.dialogVisible = true;
    },
    handleTopicChange() {
      this.form.sub_topics_card_id = "";
      if (this.form.topic_card_id) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: this.form.topic_card_id });
      }
    },
    submitForm() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          const action = this.isEdit ? "task_cards/UpdateTaskCard" : "task_cards/CreateTaskCard";
          const payload = this.isEdit ? { id: this.selectedId, form: this.form } : this.form;

          this.$store.dispatch(action, payload).then(() => {
            this.dialogVisible = false;
            Swal.fire({
              icon: "success",
              title: this.localization("Done"),
              text: this.isEdit ? this.localization("Task card updated successfully!") : this.localization("Task card created successfully!"),
              confirmButtonText: this.localization("Ok"),
              confirmButtonClass: "btn btn-success",
              buttonsStyling: false
            });
            this.refresh();
            this.resetForm();
          });
        }
      });
    },
    deleteTask(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are you sure you want to delete this task card?")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("task_cards/DeleteTaskCard", id).then(() => {
            Swal.fire({
              icon: "success",
              title: this.localization("Deleted"),
              text: this.localization("Task card deleted successfully!"),
              confirmButtonText: this.localization("Ok"),
              confirmButtonClass: "btn btn-success",
              buttonsStyling: false
            });
            this.refresh();
          });
        }
      });
    },
    restoreTask(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are you sure you want to restore this task card?")}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: `${this.localization("Restore")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("task_cards/RestoreTaskCard", id).then(() => {
            Swal.fire({
              icon: "success",
              title: this.localization("Restored"),
              text: this.localization("Task card restored successfully!"),
              confirmButtonText: this.localization("Ok"),
              confirmButtonClass: "btn btn-success",
              buttonsStyling: false
            });
            this.refresh();
          });
        }
      });
    },
    resetForm() {
      if (this.$refs.taskForm) {
        this.$refs.taskForm.resetFields();
      }
      this.form = {
        topic_card_id: "",
        sub_topics_card_id: "",
        desc: ""
      };
      this.isEdit = false;
      this.selectedId = null;
      this.dialogVisible = false;
    }
  },
  mounted() {
    this.refresh(this.filter);
    this.fetchLookups();
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

.task-form {
  margin-top: 20px;
}

.custom_modal_header {
  .images {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .close_img {
      cursor: pointer;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #101828;
    margin-bottom: 8px;
  }
  .description {
    font-size: 14px;
    color: #667085;
  }
}

.lci_modal_buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  .lci_btn_modal_cancel {
    padding: 10px 18px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid #d0d5dd;
    background: #fff;
    color: #344054;
    &.save {
      background: #7f56d9;
      color: #fff;
      border: 1px solid #7f56d9;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

.table_actions {
  display: flex;
  justify-content: center;
  align-items: center;
  .action_icon {
    cursor: pointer;
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}
</style>

<style scoped>
::v-deep .el-table .cell {
  padding-left: 20px !important;
}
::v-deep .input_with_custom_text_area .el-textarea__inner {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  white-space: pre-wrap !important;
}
</style>
